export default __webpack_public_path__ + "static/media/004-crab.62162854.svg";